export default function googleAnalytics({ app }) {
  /*
   ** Only run on client-side and only in production mode
   */
  if (process.env.NODE_ENV !== 'production' || process.server) return;
  /*
   ** Include Google Analytics Script
   */
  const script = document.createElement('script');
  script.src = 'https://www.googletagmanager.com/gtag/js?id=G-BBZYB7YVCV';
  script.async = true;
  document.head.appendChild(script);
  /*
   ** Set the current page
   */
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag('js', new Date());

  gtag('config', 'G-BBZYB7YVCV');
  gtag('config', 'AW-758426473');
  /*
   ** Every time the route changes (fired on initialization too)
   */
  app.router.afterEach((to, from) => {
    /*
     ** We tell Google Analytics to add a `pageview`
     */
    gtag('config', 'G-BBZYB7YVCV', { page_path: to.fullPath });
  });
}
